var _g, _line, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRodToBottomArc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 565.1 619",
    enableBackground: "new 0 0 565.1 619",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 72.9,
    y1: 100.6,
    x2: 72.9,
    y2: 515
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "63.9,103.2 72.9,87.7 81.9,103.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "63.9,512.4 72.9,528 81.9,512.4  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.0317,
    x1: 0,
    y1: 607.4,
    x2: 480,
    y2: 607.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M504.1,610.5v-12h7.9v1.3h-6.4v3.9h6.2v1.3h-6.2v5.5H504.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M513.8,610.5v-12h1.5v10.7h5.6v1.3H513.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M523.2,607.6c-0.5-0.9-0.7-2-0.7-3.2s0.2-2.2,0.7-3.2c0.5-0.9,1.2-1.7,2.1-2.2c0.9-0.5,1.9-0.8,3.1-0.8 c1.2,0,2.2,0.3,3.1,0.8s1.6,1.3,2.1,2.2s0.7,2,0.7,3.2s-0.2,2.2-0.7,3.2s-1.2,1.7-2.1,2.2c-0.9,0.5-2,0.8-3.1,0.8 c-1.2,0-2.2-0.3-3.1-0.8C524.4,609.3,523.7,608.6,523.2,607.6z M524,604.5c0,0.9,0.2,1.8,0.5,2.5s0.9,1.3,1.5,1.7 c0.7,0.4,1.5,0.6,2.3,0.6c0.9,0,1.7-0.2,2.3-0.6c0.7-0.4,1.2-1,1.6-1.7c0.4-0.7,0.5-1.6,0.5-2.5c0-1.4-0.4-2.6-1.2-3.5 c-0.8-0.9-1.9-1.4-3.2-1.4c-1.3,0-2.4,0.5-3.2,1.4C524.4,601.9,524,603,524,604.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M536.9,607.6c-0.5-0.9-0.7-2-0.7-3.2s0.2-2.2,0.7-3.2c0.5-0.9,1.2-1.7,2.1-2.2c0.9-0.5,1.9-0.8,3.1-0.8 c1.2,0,2.2,0.3,3.1,0.8s1.6,1.3,2.1,2.2s0.7,2,0.7,3.2s-0.2,2.2-0.7,3.2s-1.2,1.7-2.1,2.2c-0.9,0.5-2,0.8-3.1,0.8 c-1.2,0-2.2-0.3-3.1-0.8C538.1,609.3,537.4,608.6,536.9,607.6z M537.7,604.5c0,0.9,0.2,1.8,0.5,2.5s0.9,1.3,1.5,1.7 c0.7,0.4,1.5,0.6,2.3,0.6c0.9,0,1.7-0.2,2.3-0.6c0.7-0.4,1.2-1,1.6-1.7c0.4-0.7,0.5-1.6,0.5-2.5c0-1.4-0.4-2.6-1.2-3.5 c-0.8-0.9-1.9-1.4-3.2-1.4c-1.3,0-2.4,0.5-3.2,1.4C538.1,601.9,537.7,603,537.7,604.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M550.4,610.5v-12h4.8c1.1,0,2,0.3,2.7,1c0.7,0.7,1.1,1.5,1.1,2.6c0,0.5-0.1,1-0.3,1.4s-0.4,0.8-0.7,1.1 s-0.6,0.5-1,0.7s-0.8,0.3-1.2,0.3l3.2,4.9h-1.8l-3-4.7h-2.4v4.7H550.4z M551.9,604.4h3.1c0.7,0,1.3-0.2,1.7-0.6s0.7-1,0.7-1.7 s-0.2-1.2-0.7-1.7s-1-0.6-1.7-0.6h-3.1V604.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 138.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 162,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.3,
    y: 79.5,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.0951,
    width: 362,
    height: 6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 415.3,
    y: 76.5,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6,
    y: 76.5,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.8,
    y: 66,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.2,
    y: 66,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.75,
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6174,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 460.5,107.5 470,98 10.3,98 19.2,107.5 459.2,107.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 65.8,
    opacity: 0.7,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5848,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 460,
    height: 32.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodToBottomArc);
export default __webpack_public_path__ + "static/media/RodToBottom_arc.c2c49134e63904fd282c29bad47721bf.svg";
export { ForwardRef as ReactComponent };